import CustomToast from "../../components/UI/customToast";
import reduxStore from "../../configureEnvStore";
import { AR_MARKUP_VIEW, COLOR_TO_ANNOT } from "../../constants/Constants";
import { NOTIFICATION_TYPES } from "../../constants/DataTrackNotificationConstants";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../../constants/PublicVariables";
import Localize from "../../locale/Localize";
import { setCallParticipants } from "../../reducers/common-reducer";
import { setARmarkupLiveStream, setARMarkupStatusPopup, setARMarkupToastMsgStatus, setAssignedColors } from "../../reducers/markup-reducer";
import { sendDataTrack } from "../../shared/dataTrackFunction";
import extractTextService from "../extractTextService";
import { LogFirebase } from "../firestore";
import markupService from "./markupService";

class ARMarkupService {
    arMarkupStatus = {
        initiated: "0",
        started: "1",
        arDeviceSupported: "2",
    };
    ARMarkupStarted = false;
    popupStatus = {
        notSupportAR: "1",
        appNotInstalled: "2",
        needsToUpdateApp: "3",
        supportedReadyToStart: "4",
        unset: "",
    };
    arMarkupStatusToastList = {
        0: "ready_for_ar_markup",
        1: "more_light_required",
        2: "move_further_away",
        3: "slow_down",
        4: "tacking_not_available",
        5: "camera_use_bu_another_app",
        6: "move_device_to_start",
        7: "find_surface_to_measure",
    };

    handleUserARMarkupStatus = (msg) => {
        const { callParticipants } = reduxStore.getState().commonReducer;
        const updatedParticipants = callParticipants.map((user) => {
            if (user.identity === msg.identity) {
                return { ...user, ar_status: msg.ar_device_supported_status };
            }
            return user;
        });
        reduxStore.dispatch(setCallParticipants(updatedParticipants));
    };

    startStopARMarkup = (msg) => {
        if (msg && msg.ar_markup_status == this.arMarkupStatus.initiated) {
            // for guest user only
            if (!GLOBAL_MEETING_DATA.isAgent) {
                extractTextService.onStartPrepareView("ARMarkup");
                extractTextService.checkUploadTimeout("ARMarkup");
                markupService.setAnnoteColor(msg);
            }
            // here we init view
        } else if (msg && msg.ar_markup_status == this.arMarkupStatus.started) {
            // start ARMarkup
            if (!this.ARMarkupStarted) {
                this.startARMarkup(msg);
            }

            if (reduxStore.getState().markup.arMarkupLiveStream !== AR_MARKUP_VIEW.PREPARE_VIEW && msg.for_new_joinee == "1") {
                reduxStore.dispatch(setARmarkupLiveStream(AR_MARKUP_VIEW.PREPARE_VIEW));
                LogFirebase("ARMarkup", "msg_received", "for_new_joinee");
                this.ARMarkupShowPopupFunction(this.popupStatus.supportedReadyToStart);
                markupService.setAnnoteColor(msg, "ARMarkup");
            }
        } else if (msg && msg.ar_markup_status == this.arMarkupStatus.arDeviceSupported) {
            // ar device supported status ARMarkup
            this.startARMarkup(msg);
        }
    };

    startARMarkup = (msg) => {
        if (msg === undefined) {
            if (GLOBAL_MEETING_DATA.isAgent) {
                this.sendStartARMarkupDataTrack(); // Agent-specific behavior
            }
            return; // Exit early if no `msg` is provided
        }
        if (msg?.ar_markup_status == this.arMarkupStatus.started) {
            LogFirebase("ARMarkup", "receive_msg", "ARMarkup_started");
            if (!GLOBAL_MEETING_DATA.isAgent) {
                console.error("Start ar markup for guest");
            }
        } else {
            console.warn("Unhandled ARMarkup status:", msg?.ar_markup_status);
        }
    };

    sendStartARMarkupDataTrack = () => {
        const { callParticipants } = reduxStore.getState().commonReducer;
        const { streamingPartiIdentity } = reduxStore.getState().twilioEvents;
        callParticipants.forEach((user) => {
            if (user.identity == streamingPartiIdentity) {
                if (user.ar_status != "4") {
                    this.commonFuncForSendingARStatusDataTrack(this.arMarkupStatus.arDeviceSupported); // only show popup to agent and send data track with status '2'
                    this.showARMarkupStatusPopup(user.ar_status);
                } else {
                    extractTextService.onStartPrepareView("ARMarkup");
                    extractTextService.checkUploadTimeout("ARMarkup");
                    this.commonFuncForSendingARStatusDataTrack(this.arMarkupStatus.initiated); // start ARMarkup and send data track with status '0'
                }
                LogFirebase("ARMarkup", "send_msg", {
                    ar_status: user.ar_status,
                    identity: user.identity,
                });
            }
        });
        //updated firebase logs of net type
        LogFirebase("ARMarkup", "start_ARMarkup", "");
    };

    showARMarkupStatusPopup = (status) => {
        if (status == this.popupStatus.notSupportAR) {
            LogFirebase("ARMarkup", "notSupportAR_popup", { ar_status: status });
            reduxStore.dispatch(setARMarkupStatusPopup(status));
        } else if (status == this.popupStatus.appNotInstalled) {
            LogFirebase("ARMarkup", "appNotInstalled_popup", { ar_status: status });
            reduxStore.dispatch(setARMarkupStatusPopup(status));
        } else if (status == this.popupStatus.needsToUpdateApp) {
            LogFirebase("ARMarkup", "needsToUpdateApp_popup", { ar_status: status });
            reduxStore.dispatch(setARMarkupStatusPopup(status));
        } else if (status == this.popupStatus.unset) {
            reduxStore.dispatch(setARMarkupStatusPopup(status));
        } else if (status == this.popupStatus.supportedReadyToStart) {
            // do nothing
        } else {
            // do nothing
        }
    };

    ARMarkupShowPopupFunction = function (msg) {
        if (msg == this.popupStatus.supportedReadyToStart) {
            extractTextService.onExitPrepareView(true);
            const videoCallView = document.getElementById("video-call");
            videoCallView.style.display = "flex"; // Removes the "display" style
            reduxStore.dispatch(setARmarkupLiveStream(AR_MARKUP_VIEW.START_MARKUP_VIEW));
            this.ARMarkupStarted = true;
            reduxStore.dispatch(setARMarkupStatusPopup(this.popupStatus.supportedReadyToStart));
            markupService.startHDCapture("ARMarkup");
            this.addRemoveARMarkupPointerBodyCss(true);
        }
    };

    addRemoveARMarkupPointerBodyCss = (add) => {
        if (add) {
            if (GLOBAL_MEETING_DATA.isAgent) {
                CustomToast.info(Localize[PublicVariables.currentLanguageObj.languageCode]["armarkup_toast_msg_to_guide_user"]);
            }
        }
    };

    commonFuncForSendingARStatusDataTrack = (status) => {
        let msg = {};
        msg = {
            notification_type: NOTIFICATION_TYPES.AR_MARKUP.AGENT_TO_ALL,
            identity: CALL_DATA.localIdentity,
            device_type: GLOBAL_MEETING_DATA.device_type,
            ar_markup_status: status,
        };
        if (status != "2") {
            const colorsToDraw = {};
            reduxStore.getState().twilioEvents?.participantIdentities?.forEach((val, key) => {
                colorsToDraw[val] = COLOR_TO_ANNOT[key + 1];
            });
            reduxStore.dispatch(setAssignedColors(colorsToDraw));
            markupService.assignedColors = colorsToDraw;
            msg.colors = colorsToDraw;
            msg.total_remote_participations = reduxStore.getState().twilioEvents.participantIdentities?.length;
            if (status == "1") {
                msg.for_new_joinee = "1";
            }
        }
        sendDataTrack(msg);
    };

    ARMarkupStopVariable = (type) => {
        reduxStore.dispatch(setARmarkupLiveStream(AR_MARKUP_VIEW.OFF_VIEW));
        reduxStore.dispatch(setARMarkupToastMsgStatus(null));
        this.ARMarkupStarted = false;
        LogFirebase("ARMarkup", "going_to_stop", { fromWhere: type });
        this.showARMarkupStatusPopup(this.popupStatus.unset);
        this.addRemoveARMarkupPointerBodyCss(false);
        const videoCallView = document.getElementById("video-call");
        if (videoCallView?.style?.display === "none") {
            videoCallView.style.display = "flex"; // Removes the "display" style
        }
    };

    checkARMarkupIsOngoing = () => {
        return reduxStore.getState().markup.arMarkupLiveStream !== AR_MARKUP_VIEW.OFF_VIEW;
    };

    handleARMarkupRequestToStreamingUser = (msg) => {
        if (GLOBAL_MEETING_DATA.isAgent) {
            this.startStopARMarkup(msg);
        } else if (msg.ar_markup_status != this.arMarkupStatus.arDeviceSupported && !GLOBAL_MEETING_DATA.isAgent) {
            if (this.ARMarkupStarted && msg.ar_markup_status == this.arMarkupStatus.started) {
                // do nothing
            } else {
                this.startStopARMarkup(msg);
            }
        }
    };

    // handle measurement toast messages
    handleARMarkupToastMessage = (msg) => {
        reduxStore.dispatch(
            setARMarkupToastMsgStatus(
                Localize[PublicVariables.currentLanguageObj?.languageCode][this.arMarkupStatusToastList[msg.measurement_toast_msg_status]]
            )
        );
        if (msg.measurement_toast_msg_status == "0") {
            setTimeout(() => {
                if (
                    reduxStore.getState().markup.arMarkupToastMsgStatus ==
                    Localize[PublicVariables.currentLanguageObj?.languageCode][
                        this.arMarkupStatusToastList[msg?.measurement_toast_msg_status?.toString()]
                    ]
                )
                    reduxStore.dispatch(setARMarkupToastMsgStatus(null));
            }, 3000);
        }
    };
}

export default new ARMarkupService();
